module.exports = __webpack_public_path__ + "img/access-email.0b2bf8b2.png";